import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmDialogComponent } from '@shared/confirm-dialog/confirm-dialog.component';
import { PwaInstallService } from '@core/services/pwa-install.service';
import { AuthenticationService } from '@core/services/auth.service';
import { ArdiaWidgetService } from '@core/services/ardia-widget.service';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ConfirmDialogComponent],
  template: '<router-outlet></router-outlet><app-confirm-dialog></app-confirm-dialog>',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'agent_ai';
  private subscriptions = new Subscription();
  private mountedUserKey: string | null = null;

  constructor(
    private pwaInstallService: PwaInstallService,
    private authService: AuthenticationService,
    private ardiaWidgetService: ArdiaWidgetService,
  ) {
    // Ensures the PWA install listener is registered as early as possible.
    void this.pwaInstallService;
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.authService.currentUser$
        .pipe(
          map((user) => this.getUserKey(user)),
          distinctUntilChanged(),
        )
        .subscribe((userKey) => {
          if (!userKey) {
            this.mountedUserKey = null;
            this.ardiaWidgetService.unmount();
            return;
          }

          const shouldForceReinit =
            this.mountedUserKey !== null && this.mountedUserKey !== userKey;
          this.mountedUserKey = userKey;

          void this.ardiaWidgetService.mount(shouldForceReinit).catch((error) => {
            console.error('No se pudo inicializar el widget de Ardia:', error);
          });
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.ardiaWidgetService.unmount();
  }

  private getUserKey(user: unknown): string | null {
    if (!user || typeof user !== 'object') {
      return null;
    }

    const record = user as Record<string, unknown>;
    if (record['id'] !== undefined && record['id'] !== null) {
      return String(record['id']);
    }
    if (typeof record['email'] === 'string' && record['email'].trim().length > 0) {
      return record['email'];
    }
    if (typeof record['name'] === 'string' && record['name'].trim().length > 0) {
      return record['name'];
    }

    return 'authenticated-user';
  }
}
